{
  "greeting": {
    "salam": "Assalamu alaikum",
    "salamWithName": "Assalamu alaikum, {{name}}"
  },
  "dock": {
    "saved": "Imehifadhiwa",
    "savedVerses": "Aya zilizohifadhiwa",
    "tasks": "Kazi",
    "notes": "Madokezo"
  },
  "actions": {
    "save": "Hifadhi",
    "cancel": "Ghairi",
    "close": "Funga",
    "delete": "Futa",
    "rename": "Badilisha jina",
    "dismiss": "Ondoa",
    "loading": "Inapakia…",
    "reload": "Pakia upya",
    "retry": "Jaribu tena",
    "expand": "Panua",
    "collapse": "Kunja"
  },
  "nav": {
    "appNavigation_aria": "Urambazaji wa programu"
  },
  "tabs": {
    "home": "Mwanzo",
    "tasks": "Kazi",
    "notes": "Madokezo",
    "more": "Zaidi"
  },
  "more": {
    "daily": "Kila siku",
    "account": "Akaunti",
    "savedVerses": "Aya zilizohifadhiwa",
    "qibla": "Kibla",
    "prayerTimes": "Nyakati za Sala na Vikumbusho",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Inasimamiwa kupitia akaunti yako ya Rhemn",
    "upgrade": "Boresha",
    "privacyPolicy": "Sera ya Faragha",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Rudi",
    "deleteAccount": "Futa akaunti"
  },
  "reflection": {
    "dismiss_aria": "Ondoa tafakuri"
  },
  "app": {
    "loading_aria": "Rhemn inapakia",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Simamia usajili wako wa Rhemn Pro kwenye wavuti. Pro hufunguliwa kiotomatiki hapa unapoingia kwa akaunti yako iliyojisajili."
  },
  "header": {
    "qiblaDirection_aria": "Mwelekeo wa Kibla",
    "prayerTimes_aria": "Nyakati za swala",
    "prayerTimesTitle": "Nyakati za Swala",
    "method": "Mbinu",
    "methodHelp": "Mbinu huathiri nyakati zilizokokotolewa"
  },
  "search": {
    "search_aria": "Tafuta",
    "searchLabel": "Tafuta",
    "searchWeb_placeholder": "Tafuta kwenye wavuti"
  },
  "focus": {
    "input_placeholder": "Ni kipi muhimu zaidi leo?",
    "example_worship": "Kuswali kwa unyenyekevu, bila haraka",
    "example_kindness": "Kumpigia mama simu ili kumsikiliza tu",
    "example_reflect": "Tafakari nia yako pamoja na aya ya leo",
    "saveIntention_aria": "Hifadhi nia",
    "celebration": "🤲 Mashalla"
  },
  "profile": {
    "profileFallback": "Wasifu",
    "profileAndAccount_aria": "Wasifu na akaunti",
    "profileDialog_aria": "Wasifu",
    "editName_aria": "Hariri jina lako",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Simamia usajili",
    "manageSubscription_aria": "Simamia usajili wako wa Rehmn Pro",
    "anonymousAnalytics": "Takwimu zisizojulikana",
    "anonymousAnalyticsNote": "Za jumla tu — hazihusishwi nawe kamwe",
    "shareAnalytics_aria": "Shiriki takwimu zisizojulikana za matumizi",
    "signOut": "Toka",
    "signingOut": "Inatoka…",
    "signOut_aria": "Toka katika Rehmn",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "Inapakia mandharinyuma...",
    "fallbackNotice": "Inatumia picha mbadala (API ya Unsplash haipatikani)",
    "noImage": "Hakuna picha ya mandharinyuma inayopatikana",
    "error": "Hitilafu: {{message}}",
    "photoByOnUnsplash": "Picha na <photographer>{{name}}</photographer> kwenye <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Hitilafu imetokea",
    "fallbackMessage": "Hitilafu isiyotarajiwa imetokea."
  },
  "theme": {
    "switchToLight_title": "Badilisha hadi hali ya mwanga",
    "switchToDark_title": "Badilisha hadi hali ya giza"
  },
  "upgradeCta": {
    "upgradeToPro": "Pandisha hadi Pro",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "pricePerMonth": "{{price}} / mwezi",
    "pricePerYear": "{{price}} / mwaka",
    "purchasePending": "Inasubiri idhini. Pro itafunguliwa kiotomatiki mara ununuzi utakapoidhinishwa.",
    "storeUnavailable": "App Store haipatikani kwa sasa. Jaribu tena baada ya muda mfupi.",
    "purchaseFailed": "Ununuzi haukukamilika. Jaribu tena baada ya muda mfupi."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · Punguzo la 25% mwaka wa kwanza",
    "title": "Kwa saa zilizo kati ya swala zako.",
    "body": "Maelezo ya sauti yanayonakiliwa, kufupishwa na kuwa kazi. Mpangilio wa siku uliojengwa kuzunguka nyakati zako za swala. Maelezo kwa AI.",
    "price": "$29.99",
    "period": "kwa mwaka wako wa kwanza",
    "priceIos": "Punguzo la 25% mwaka wa kwanza",
    "terms": "Kisha $39.99 kwa mwaka. Msimbo {{code}} umewekwa kwa ajili yako.",
    "termsIos": "Husasishwa kwa bei ya kawaida ya mwaka. Tumia msimbo {{code}} kwenye App Store.",
    "free": "Nyakati za swala, Qibla, aya ya siku na kazi zinabaki bure.",
    "cta": "Pandisha hadi Pro",
    "dismiss": "Si sasa"
  },
  "planChooser": {
    "monthly": "Kila mwezi",
    "yearly": "Kila mwaka",
    "yearlyValue": "Miezi minne kutoka kwetu.",
    "freeNote": "Nyakati za sala, Kibla, aya ya siku na kazi ni bure. Rhemn Pro huongeza:",
    "includes_planner": "Mpango wa siku uliojengwa kuzunguka sala tano, na “Panga siku yangu”",
    "includes_insights": "Quran Insights — uliza swali kuhusu aya yoyote na usome muktadha wake",
    "includes_reflections": "Tafakari za aya ya siku, zilizoandikwa kwa nia uliyoweka",
    "includes_notes": "Madokezo na madokezo ya sauti, yenye muhtasari wa AI",
    "includes_extras": "Aya zilizohifadhiwa, kadi za aya, mfululizo wa siku na utabiri wa siku 5",
    "renewsMonthly": "Hujirudia kila mwezi hadi utakapoghairi",
    "renewsYearly": "Hujirudia kila miezi 12 hadi utakapoghairi",
    "continue": "Endelea",
    "renewalTerms": "Malipo hukatwa kwenye Apple ID yako wakati wa uthibitisho. Usajili hujirudia kiotomatiki isipokuwa ujirudiaji kiotomatiki uzimwe angalau saa 24 kabla ya kipindi kuisha. Dhibiti au ghairi wakati wowote katika mipangilio ya Apple ID.",
    "retry": "Jaribu tena"
  },
  "streak": {
    "badge_aria": "Mfululizo wa kila siku — siku {{count}}",
    "title": "Mfululizo wa kila siku",
    "daysWithCount": "Mfululizo wa siku {{count}}",
    "start": "Anza leo — tumia muda kidogo na aya au weka alama ya swala.",
    "prayedToday": "Nimeswali leo",
    "readVerse": "Nimesoma aya ya leo",
    "autoHint": "Aya hujiwekea alama yenyewe unapotumia muda kidogo nayo.",
    "milestoneTitle": "Siku {{count}} za nia",
    "milestoneBody": "Alhamdulillah. Shiriki hatua hii — mpendwa wako naye huenda akaanza.",
    "share": "Shiriki",
    "dismiss": "Si sasa",
    "cardLabel": "siku za nia",
    "shareCaption": "Siku {{count}} za kuanza kwa nia — rhemn.com",
    "imageSaved": "Picha imehifadhiwa.",
    "couldNotCreateImage": "Imeshindikana kuunda picha. Tafadhali jaribu tena."
  },
  "qibla": {
    "compassIcon_aria": "Aikoni ya dira",
    "title": "Mwelekeo wa Kibla",
    "locationUnavailable": "Eneo halipatikani",
    "locating": "Inatafuta eneo…",
    "compass_aria": "Dira ya Kibla",
    "directionN": "K",
    "directionE": "Ma",
    "directionS": "Kus",
    "directionW": "Mag",
    "facingQibla": "Unaelekea Kibla",
    "enableLiveCompass": "Washa Dira Hai",
    "enableLiveCompassNote": "Hutumia kihisi cha mwendo ili mshale ufuate unapogeuka — si eneo",
    "directionToMecca": "Mwelekeo wa Makka",
    "enableLocation": "Washa ufikiaji wa eneo ili kukokotoa mwelekeo",
    "hintLive": "Mshale hufuatilia mwelekeo wa kifaa chako wakati halisi",
    "hintStatic": "Mwelekeo kutoka Kaskazini — tumia na dira kwa mwelekeo sahihi",
    "live": "Hai",
    "footerVerse": "\"Basi elekeza uso wako upande wa Msikiti Mtakatifu\" – Quran 2:144"
  },
  "legal": {
    "links_aria": "Kisheria",
    "termsOfUse": "Masharti ya Matumizi",
    "privacyPolicy": "Sera ya Faragha"
  },
  "auth": {
    "signInForPro": "Ingia kwanza — Pro yako inakwenda nawe kila mahali."
  },
  "integrations": {
    "row": {
      "label": "Kalenda na kazi",
      "caption": "Imeunganishwa",
      "subNone": "Haijaunganishwa",
      "subFree": "Google Calendar, Google Tasks na zaidi",
      "subAttention": "{{provider}} inahitaji uangalizi",
      "subPaused": "Usawazishaji umesitishwa"
    },
    "list": {
      "title": "Kalenda na kazi",
      "subtitle": "Leta mikutano na mambo yako ya kufanya katika siku yako.",
      "footnote": "Rhemn husoma tu kile kinachohitajika, na haihifadhi matukio yako kamwe.",
      "privacy": "Sera ya Faragha",
      "connect": "Unganisha",
      "connect_aria": "Unganisha {{what}}",
      "checking": "Inakagua…",
      "loadError": "Imeshindwa kupakia miunganisho yako.",
      "tryAgain": "Jaribu tena",
      "offline": "Huko mtandaoni. Unganisha ukirudi mtandaoni.",
      "unavailable": "Kalenda na kazi hazipatikani kwa sasa.",
      "disconnected": "{{provider}} imekatwa.",
      "google": {
        "name": "Google",
        "sub": "Kalenda na Kazi",
        "what": "Google Calendar na Google Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Kazi na miradi",
        "what": "Todoist"
      },
      "apple": {
        "name": "Kalenda na Vikumbusho",
        "subNative": "Kwenye {{device}} hii",
        "subSafari": "Katika programu ya Rhemn kwa iPhone na Mac"
      },
      "synced": "Imesawazishwa {{when}}",
      "connectedSub": "Imeunganishwa",
      "syncing": "Inasawazisha…",
      "reconnectSub": "Unganisha upya ili kuendelea kusawazisha",
      "errorSub": "Usawazishaji wa mwisho haukukamilika",
      "pausedSub": "Imesitishwa · Rhemn Pro imeisha"
    },
    "explainer": {
      "google": {
        "title": "Unganisha Google Calendar na Google Tasks",
        "p1Lead": "Kalenda yako, kusoma tu",
        "p1Body": "Rhemn huonyesha matukio yako katika siku yako na hujua unapokuwa na shughuli. Haiyahifadhi.",
        "p2Lead": "Google Tasks, pande zote mbili",
        "p2Body": "Orodha unazochagua zinaendelea kusawazishwa, hivyo unaweza kuzikamilisha popote.",
        "p3Lead": "Unaweza kughairi wakati wowote",
        "p3Body": "Katisha muunganisho wakati wowote, hapa au katika Akaunti yako ya Google.",
        "footnote": "Google itaonyesha kabisa kile Rhemn inachoomba."
      },
      "todoist": {
        "title": "Unganisha Todoist",
        "p1Lead": "Miradi yako, pande zote mbili",
        "p1Body": "Miradi unayochagua inaendelea kusawazishwa, hivyo unaweza kuikamilisha popote.",
        "p2Lead": "Jinsi inavyolingana",
        "p2Body": "Vipaumbele vya Todoist vinakuwa Muhimu Sana, Juu, Wastani na Chini. Kazi ndogo zenye kina zaidi ya ngazi moja huonekana kama hatua chini ya kazi yake kuu.",
        "p3Lead": "Unaweza kughairi wakati wowote",
        "p3Body": "Katisha muunganisho wakati wowote, hapa au katika mipangilio ya Todoist.",
        "cta": "Endelea kwenda Todoist",
        "footnote": "Todoist itakuomba uthibitishe."
      },
      "skip": "Si sasa",
      "cancel": "Ghairi",
      "waiting": "Inasubiri {{provider}}…",
      "safariWaiting": "Maliza katika kichupo kipya, kisha rudi hapa.",
      "safariReopen": "Fungua kichupo tena",
      "denied": "{{provider}} haikutoa ufikiaji, hivyo hakuna kilichounganishwa.",
      "error": "Imeshindwa kuunganisha na {{provider}}. Jaribu tena baada ya muda."
    },
    "detail": {
      "back_aria": "Rudi kwenye Kalenda na kazi",
      "syncNow": "Sawazisha sasa",
      "intro": "Chagua kile Rhemn inachosawazisha. Unaweza kubadilisha hili wakati wowote.",
      "taskLists": "Orodha za kazi",
      "projects": "Miradi",
      "reminders": "Vikumbusho",
      "calendars": "Kalenda",
      "rhemnCalendarSub": "Nyakati zako za sala, hazihesabiwi kama una shughuli",
      "loading": "Inapakia…",
      "loadError": "Imeshindwa kupakia orodha zako.",
      "emptyGoogle": "Hakuna orodha za kazi katika Google Tasks.",
      "emptyTodoist": "Hakuna miradi katika Todoist.",
      "addError": "Imeshindwa kuongeza {{name}}. Jaribu tena.",
      "removed": "Imeondolewa kutoka Rhemn. Bado ipo katika {{provider}}.",
      "undo": "Tendua",
      "prayerTimes": "Ongeza nyakati za sala kwenye kalenda yako",
      "prayerTimesSub": "Huongeza sala tano kwenye kalenda inayoitwa Rhemn, kwa siku 7 zijazo, ili watu wasipange shughuli wakati huo.",
      "prayerTimesOn": "Imewashwa. Imeongezwa hadi {{date}}.",
      "prayerTimesWaiting": "Inasubiri Google…",
      "prayerTimesDenied": "Google haikuruhusu. Hakuna kilichoongezwa.",
      "prayerTimesRemoveAsk": "Ondoa nyakati za sala za Rhemn kutoka kwenye kalenda yako?",
      "prayerTimesKeep": "Ziache",
      "prayerTimesRemove": "Ondoa",
      "meetingPrompts": "Vikumbusho vya mikutano",
      "meetingPromptsSub": "Wakati mkutano wenye kiungo unapokaribia kuanza, hutoa kuchukua kumbukumbu.",
      "busyFootnote": "\"Panga siku yangu\" huona tu wakati una shughuli, kamwe haioni yaliyomo katika mikutano yako.",
      "todoistFootnote": "Vipaumbele vya Todoist vinakuwa Muhimu Sana, Juu, Wastani na Chini. Kazi ndogo zenye kina zaidi ya ngazi moja huonekana kama hatua chini ya kazi yake kuu.",
      "reauth": "{{provider}} imeacha kuruhusu Rhemn kusawazisha. Hii hutokea pale ufikiaji unapoondolewa au nenosiri lako linapobadilika.",
      "reconnect": "Unganisha upya",
      "paused": "Usawazishaji umesitishwa kwa sababu Rhemn Pro imeisha. Orodha zako zinabaki kama zilivyokuwa.",
      "calendarDenied": "Ufikiaji wa kalenda umezimwa.",
      "remindersDenied": "Ufikiaji wa vikumbusho umezimwa.",
      "disconnect": "Kata muunganisho wa {{provider}}",
      "disconnectTitle": "Kata muunganisho wa {{provider}}?",
      "disconnectBody": "Hakuna kinachofutwa katika {{provider}}.",
      "disconnectRhemnCal": "Kalenda yako ya nyakati za sala ya Rhemn itaondolewa kutoka Google Calendar.",
      "disconnectError": "Imeshindwa kukata muunganisho wa {{provider}}. Jaribu tena baada ya muda.",
      "keepLists": "Weka orodha zangu katika Rhemn",
      "keepListsSub": "Zitaacha kusawazishwa na kuwa orodha za kawaida za Rhemn.",
      "removeLists": "Ziondoe kutoka Rhemn",
      "removeListsSub": "Nakala zilizo katika Rhemn pekee ndizo zitaondolewa.",
      "disconnecting": "Inakata muunganisho…",
      "appleStop": "Acha kutumia Kalenda na Vikumbusho",
      "appleStopTitle": "Acha kutumia Kalenda na Vikumbusho?",
      "appleStopBody": "Rhemn itaacha kuonyesha matukio na vikumbusho vyako. Ili kuondoa ufikiaji wake kikamilifu, izime katika Mipangilio.",
      "justNow": "sasa hivi",
      "tasksScope": "Rhemn inahitaji ruhusa ya kuona Google Tasks yako. Unganisha upya kisha uweke alama kwenye Kazi ili kuruhusu.",
      "calendarsLoadError": "Imeshindwa kupakia kalenda zako.",
      "calendarsEmpty": "Hakuna kalenda katika akaunti hii.",
      "calendarsScope": "Rhemn inahitaji ruhusa ya kuona Google Calendar yako. Unganisha upya na uchague Calendar ili kuruhusu.",
      "prayerTimesError": "Imeshindwa kuongeza nyakati zako za sala. Jaribu tena baada ya muda mfupi.",
      "remindersEmpty": "Hakuna orodha katika Vikumbusho.",
      "openSettings": "Fungua Mipangilio",
      "appleStopCta": "Acha kutumia"
    },
    "locked": {
      "body": "Ona mikutano yako ndani ya vipindi vyako vya sala, na weka Google Tasks ikisawazishwa na Rhemn.",
      "googleName": "Google Calendar na Google Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "kifaa"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, imesawazishwa na {{provider}}",
      "unlinkConfirm": "Ondoa “{{name}}” kutoka Rhemn? Itabaki katika {{provider}}.",
      "remove": "Ondoa",
      "offline": "Nje ya mtandao · Mabadiliko yatasawazishwa hadi {{provider}} ukirudi mtandaoni.",
      "stillSyncing": "Bado inasawazisha na {{provider}}…",
      "failed_one": "Badiliko {{count}} halikufika {{provider}}.",
      "failed_other": "Mabadiliko {{count}} hayakufika {{provider}}.",
      "retry": "Jaribu tena",
      "needsReconnect": "{{provider}} inahitaji uunganishe upya.",
      "paused": "Usawazishaji umesitishwa · Rhemn Pro imeisha.",
      "upgrade": "Boresha",
      "notSynced": "Haijasawazishwa",
      "notSynced_aria": "Haijasawazishwa na {{provider}}. Jaribu tena.",
      "remindersOff": "Rhemn haiwezi kufikia Vikumbusho. Iwashe tena katika Mipangilio.",
      "dueToday": "Leo",
      "dueTomorrow": "Kesho",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Siku nzima",
      "more": "+{{count}}",
      "more_aria": "Onyesha matukio {{count}} zaidi ya siku nzima",
      "less_aria": "Onyesha matukio machache ya siku nzima",
      "events_aria": "Matukio",
      "event_aria": "{{start}} hadi {{end}}, {{title}}",
      "allDayEvent_aria": "Siku nzima, {{title}}",
      "untitled": "Nina shughuli",
      "now": "Sasa · hadi {{end}}",
      "until": "hadi {{end}}",
      "into": "· hadi {{prayer}}",
      "loadError": "Imeshindwa kupakia kalenda yako.",
      "needsReconnect": "Google Calendar inahitaji uunganishe upya.",
      "scope": "Rhemn haiwezi kuona Google Calendar yako. Unganisha upya na uchague Calendar ili kuruhusu.",
      "appleOff": "Rhemn haiwezi kuona kalenda yako. Iwashe tena katika Mipangilio."
    },
    "plan": {
      "mostlyMeetings": "Mikutano zaidi · {{duration}} huru",
      "noFreeTime": "Hakuna muda huru",
      "aroundMeetings_one": "Imepangwa kuzunguka mkutano {{count}}.",
      "aroundMeetings_other": "Imepangwa kuzunguka mikutano {{count}}.",
      "settledBusy": "Kila kitu tayari kinatoshea kuzunguka mikutano yako."
    },
    "meeting": {
      "group_aria": "Mkutano unaanza",
      "now": "sasa",
      "takeNotes": "Andika kumbukumbu",
      "takeNotes_aria": "Andika kumbukumbu za {{title}}",
      "dismiss_aria": "Funga",
      "announce": "{{title}} inaanza {{when}}.",
      "announceNow": "{{title}} inaanza sasa.",
      "yourMeeting": "Mkutano wako"
    },
    "apple": {
      "primer": {
        "title": "Onyesha kalenda yako kando ya sala zako",
        "body": "Rhemn husoma matukio na vikumbusho kwenye {{device}} hii ili kuviweka katika siku yako. Vinabaki kwenye kifaa chako. Panga siku yangu hutumia tu nyakati ulizo na shughuli.",
        "cta": "Endelea",
        "skip": "Si sasa",
        "footnote": "{{device}} itauliza mara mbili, mara moja kwa Kalenda na mara moja kwa Vikumbusho. Unaweza kubadilisha chochote kati ya hivyo katika Mipangilio."
      }
    }
  }
}
